<template lang="pug">
v-container(fluid class="tw-p-0 tw-m-0 tw-rounded-md tw-overflow-hidden ")
  div(
    class="tw-rounded-md tw-border tw-border-blueGray-lighten-4 "
    :class="{ 'tw-opacity-50': loading, 'k-task-edit-bg': edit, 'tw-bg-white': !edit }"
  )
    v-row(no-gutters align="center" justify="space-between" align-content="stretch" class="tw-mx-4")
      v-col(cols="6" class=" ")
        v-form(@keyup.native.enter="update()")
          v-row(no-gutters align="center" justify="start")
            v-col(cols="auto" class="tw-ml-2")
              v-checkbox(v-model="task.status" @change="update()" :ripple="false" color=" indigo lighten-2")
            v-col(cols="10" class="tw-mb-1 tw-ml-1 tw-font-medium tw-text-base")
              v-text-field(
                v-if="edit"
                v-model="task.name"
                dense
                autofocus
                single-line
                solo
                full-width
                flat
                hide-details
                @blur="editToggle"
                background-color="#f7f7f7"
                class=" tw-border-0 tw-px-0 tw-mx-0 tw-font-medium tw-text-base k-task-input"
              )
              v-text-field(class=" tw-hidden ")
              span(v-if="!edit" class="tw-font-medium tw-text-base " @click="editToggle") {{ task.name }}
      v-col(cols="5")
        v-row(no-gutters justify="end")
          v-col(cols="auto")
            v-menu(
              bottom
              left
              nudge-bottom="35"
              nudge-left="5"
              ma-0
              pa-0
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  small
                  fab
                  :ripple="false"
                  depressed
                  v-on="on"
                  v-bind="attrs"
                  color="white"
                )
                  v-icon(color="blue-grey lighten-4") mdi-tag
              v-list(dark dense style="background-color: #424242" min-width="120px")
                v-list-item(class="tw-p-0")
                  v-btn(
                    small
                    left
                    tile
                    block
                    pa-0
                    ma-0
                    text
                    @click="setType(1)"
                    class=" tw-items-center tw-justify-start tw-my-1 "
                  )
                    div
                      v-icon mdi-phone
                      span(class="tw-pl-1") Call
                v-list-item(class="tw-p-0")
                  v-btn(
                    small
                    left
                    tile
                    block
                    pa-0
                    ma-0
                    text
                    @click="setType(2)"
                    class=" tw-items-center tw-justify-start tw-my-0 "
                  )
                    div
                      v-icon mdi-calendar
                      span(class="tw-pl-1") Meeting
                v-list-item(class="tw-p-0")
                  v-btn(
                    small
                    left
                    tile
                    block
                    pa-0
                    ma-0
                    text
                    @click="setType(3)"
                    class=" tw-items-center tw-justify-start tw-my-0 "
                  )
                    div
                      v-icon mdi-email
                      span(class="tw-pl-1") Email
            div(v-if="taskLabel" class=" tw-inline-block ")
              span {{ taskLabel }}
          v-col(cols="auto")
            v-menu(bottom left rounded="xl" nudge-bottom="35")
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  fab
                  small
                  :ripple="false"
                  v-on="on"
                  v-bind="attrs"
                  depressed
                  color="white"
                )
                  v-icon(color="blue-grey lighten-4") mdi-calendar
              v-date-picker(
                flat
                no-title
                dark
                v-model="task.due_date"
                locale="en"
                @change="update"
                :min="this.$moment().format('YYYY-MM-DD')"
                :max="this.$moment().add(5, 'years').format('YYYY-MM-DD')"
                elevation="0"
                class=" tw-border-none tw-rounded-sm"
              )
            template(v-if="task.due_date" class="tw-inline-block")
              span(class="tw-pr-2") {{ dueDateLabel }}
          v-col(cols="auto")
            v-menu(
              bottom
              left
              nudge-bottom="35"
              nudge-left="5"
              ma-0
              pa-0
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  small
                  fab
                  :ripple="false"
                  depressed
                  v-on="on"
                  v-bind="attrs"
                  color="white"
                )
                  v-icon(color="blue-grey lighten-4") mdi-account
              v-list-item-group(
                dark
                v-model="task.user"
                dense
                style="background-color: #424242"
                min-width="120px"
              )
                v-list-item(class="tw-p-0" @click="update()")
                  v-btn(
                    small
                    left
                    tile
                    plain
                    block
                    pa-0
                    ma-0
                    text
                    @click="task.user = null"
                    class=" tw-items-center tw-justify-start tw-my-1 "
                  )
                    div
                      v-icon(color="blue-grey lighten-4") mdi-cancel
                      span(class="tw-pl-1") Not assigned
                div(v-for="member in members" :key="member.id" @click="update()")
                  v-list-item(class="tw-p-0" :value="member")
                    v-btn(
                      small
                      left
                      tile
                      plain
                      block
                      pa-0
                      ma-0
                      text
                      class=" tw-items-center tw-justify-start tw-my-1 "
                    )
                      div
                        v-icon(color="blue-grey lighten-4") mdi-account
                        span(class="tw-pl-1") {{ member.name }}
            div(v-if="task.user" class=" tw-inline-block ")
              span {{ task.user.name }}

      v-col(cols="auto" class="tw-mr-1")
        v-btn(
          :ripple="false"
          icon
          @click="remove()"
          elevation="0"
          color=" blue-grey lighten-1"
        )
          v-icon mdi-trash-can-outline
</template>
<script>
export default {
  props: {
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      edit: false,
    };
  },
  computed: {
    taskLabel() {
      let type = this.task.type;
      switch (type) {
        case 1:
          type = 'Call';
          break;
        case 2:
          type = 'Meeting';
          break;
        case 3:
          type = 'Email';
          break;
        default:
          break;
      }
      return type;
    },
    dueDateLabel() {
      return this.$moment(this.task.due_date).format('MMM Do YYYY');
    },
    members() {
      return this.$store.getters['team/members'];
    },
    assignedUser() {
      return this.$store.getters['user/profile'];
    },
  },
  methods: {
    init() {
      if (this.$store.getters['team/members'].length < 1) {
        this.$store.dispatch('team/getMembers');
      }
    },
    remove() {
      this.loading = true;
      this.$store
        .dispatch('opportunities/tasks/delete', [this.$route.params.id, this.task.id])
        .then((response) => {
          this.loading = false;
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
    editToggle() {
      if (this.edit) {
        this.update();
      } else {
        return (this.edit = !this.edit);
      }
    },
    setType(type) {
      this.task.type = type;
      this.update();
    },
    update() {
      this.edit = false;
      if (this.task.user) {
        this.task.user_id = this.task.user.id;
      } else {
        this.task.user_id = null;
      }
      this.$store.dispatch('opportunities/tasks/update', [this.$route.params.id, this.task]);
    },
  },
};
</script>
<style lang="stylus">
.k-task-input .v-input__slot
    padding-left: 0px !important

.k-task-input input
    font-size: 16px !important

.k-task-edit-bg
    background-color: #f7f7f7
</style>
